import { pushToDataLayer } from "./analytics.js";

const fetchIPInfo = async (url, errorHandler) => {
  try {
    const token = document
      .querySelector('meta[name="ipinfo-token"]')
      ?.getAttribute("content");

    // Skip external API request if token is blank
    if (url === "https://ipinfo.io" && (!token || token.trim() === "")) {
      throw new Error("IPinfo token is not configured");
    }

    const response = await fetch(url, {
      headers:
        url === "https://ipinfo.io"
          ? {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            }
          : {},
    });

    if (!response.ok) throw new Error("Response not OK");

    const data = await response.json();

    // Check if the response contains an error (like token restrictions)
    if (data.error) {
      return null;
    }

    return data;
  } catch (error) {
    // GA4 parameters must be primitives - an Error object serialises to {}.
    // JS allows throwing non-Errors, so fall back rather than report undefined.
    pushToDataLayer(errorHandler, {
      error_message: error?.message ?? String(error),
    });
    return null;
  }
};

export async function fetchVisitorIP() {
  const cacheKey = "ipinfo";
  const ttl = 86400000; // 24 hours
  const cachedItem = localStorage.getItem(cacheKey);
  if (cachedItem) {
    const { data, timestamp } = JSON.parse(cachedItem);
    if (timestamp + ttl > Date.now()) {
      return data;
    }
  }

  const data =
    (await fetchIPInfo("https://ipinfo.io", "client_id_fetch_failure")) ||
    (await fetchIPInfo("/ipinfo", "client_id_fetch_failure_local"));

  if (data) {
    localStorage.setItem(
      cacheKey,
      JSON.stringify({ data, timestamp: Date.now() }),
    );
  }

  return data;
}
